import { Dayjs } from 'dayjs';

function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function getOneYearAgo(date: Date): Date {
  const oneYearAgo = new Date(date);
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
  return oneYearAgo;
}

const today = new Date();
const oneYearAgoDate = getOneYearAgo(today);

const formatDayjsDate = (date: Dayjs | null): string => {
  return date ? date.format('YYYY-MM-DD') : '';
};

export const getCurrentDate = () => {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const getOrdinalSuffix = (day: number): string => {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const generateDatesWithSuffixesForCurrentMonth =
  (): string[] => {
    const dates: string[] = [];
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const lastDay = new Date(year, month + 1, 0).getDate();

    for (let day = 1; day <= lastDay; day++) {
      const suffix = getOrdinalSuffix(day);
      dates.push(`${day}${suffix}`);
    }

    return dates;
  };

export const getCurrentMonthRange = (): {
  DateFrom: string;
  DateTo: string;
  MonthName: string;
} => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();

  const firstDayOfMonth = new Date(year, month, 1);
  const lastDayOfMonth = new Date(year, month + 1, 0);

  const formatDate = (date: Date): string => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const monthName = now.toLocaleString('default', { month: 'long' });

  return {
    DateFrom: formatDate(firstDayOfMonth),
    DateTo: formatDate(lastDayOfMonth),
    MonthName: monthName,
  };
};

export default {
  startedDate: formatDate(oneYearAgoDate),
  endedDate: formatDate(today),
  formatDayjsDate: formatDayjsDate,
};
